import { EventDetail, EventForm } from './eventTypes';

export function formFromEvent(event: EventDetail): EventForm {
  return {
      host_id: event.host_id,
      title: event.title,
      description: event.description || '',
      event_type: event.event_type || 'cruise',
      privacy_level: event.privacy_level || 'public',
      meetup_time: event.meetup_time ? new Date(event.meetup_time).toISOString().slice(0, 16) : '',
      kick_stands_up_time: event.kick_stands_up_time ? new Date(event.kick_stands_up_time).toISOString().slice(0, 16) : '',
      location_name: event.location_name || '',
      address: event.address || '',
      city: event.city || '',
      state: event.state || '',
      latitude: event.latitude?.toString() || '',
      longitude: event.longitude?.toString() || '',
      max_participants: event.max_participants?.toString() || '',
      skill_level: event.skill_level || '',
      riding_style: event.riding_style || '',
      riding_style_min: event.riding_style_min || '',
      riding_style_max: event.riding_style_max || '',
      route_type: event.route_type || 'urban',
      lane_filtering: event.lane_filtering || '',
      host_notes: event.host_notes || '',
      participant_rules: event.participant_rules || '',
      gps_start_latitude: event.gps_start_latitude?.toString() || '',
      gps_start_longitude: event.gps_start_longitude?.toString() || '',
      gps_end_latitude: event.gps_end_latitude?.toString() || '',
      gps_end_longitude: event.gps_end_longitude?.toString() || '',
      enable_route_sharing: event.enable_route_sharing ?? true,
      chat_locked: event.chat_locked ?? false,
      chat_room_start_time: event.chat_room_start_time || 'immediately',
      allowed_gender: event.allowed_gender || '',
      invite_code: event.invite_code || '',
      status: event.status || 'scheduled',
      motorcycle_restrictions: {
        makes: event.motorcycle_restrictions?.makes || [],
        yearMin: event.motorcycle_restrictions?.yearMin?.toString() || '',
        yearMax: event.motorcycle_restrictions?.yearMax?.toString() || '',
        displacementMin: event.motorcycle_restrictions?.displacementMin?.toString() || '',
        displacementMax: event.motorcycle_restrictions?.displacementMax?.toString() || '',
      },
  };
}
